import axiosInstance from '../main';

const ATTACHMENT_ERROR_CODES = [
    'ORDER_ATTACHMENT_REQUIRED',
    'ORDER_ATTACHMENT_INVALID_TYPE',
    'ORDER_ATTACHMENT_TOO_LARGE',
    'ORDER_ATTACHMENT_MISSING',
    'ORDER_ATTACHMENT_DISABLED',
];

export const MIME_EXTENSIONS = {
    'image/png': ['png'],
    'image/jpeg': ['jpg', 'jpeg'],
    'application/pdf': ['pdf'],
};

function filenameFromHeader(header) {
    const match = /filename="?([^";]+)"?/i.exec(header || '');
    return match ? match[1] : null;
}

// With responseType blob, an error body also arrives as a Blob: read it back as JSON
async function errorMessageFromBlob(data) {
    if (!(data instanceof Blob)) {
        return data?.error?.message ?? null;
    }
    try {
        return JSON.parse(await data.text())?.error?.message ?? null;
    } catch (e) {
        return null;
    }
}

export default {
    methods: {
        // Downloads through axios so the session and Woe-Sold-To headers are sent
        async downloadOrderAttachment(id, fallbackName) {
            let response;
            try {
                response = await axiosInstance.get(this.$woe_api_uri + '/order/file/' + id, {
                    responseType: 'blob'
                });
            } catch (error) {
                const message = await errorMessageFromBlob(error.response?.data);
                const notFound = [403, 404].includes(error.response?.status);
                throw new Error(notFound ? this.$t('order_attachment.not_found') : this.attachmentFriendlyError(message));
            }

            const extension = (MIME_EXTENSIONS[response.data.type] ?? ['bin'])[0];
            const name = filenameFromHeader(response.headers['content-disposition']) ?? `${fallbackName}.${extension}`;
            const url = window.URL.createObjectURL(response.data);
            // an anchor click is not blocked by popup blockers after an async request
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            link.remove();
            // revoking right after click() can cancel the download in some browsers
            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        },
        attachmentErrorMessage(message) {
            return ATTACHMENT_ERROR_CODES.includes(message)
                ? this.$t('order_attachment.' + message)
                : message;
        },
        // Only known codes are shown as is; raw server messages are replaced by a generic one
        attachmentFriendlyError(message) {
            return ATTACHMENT_ERROR_CODES.includes(message)
                ? this.$t('order_attachment.' + message)
                : this.$t('unexpected_error');
        }
    }
}
